import type { RecordView } from '@kit/sync/types/record-view';
import { DOCUMENT_CATEGORY_LABELS } from '@/entities/document/config/document-category-labels';
import { documentDue } from '@/entities/document/helpers/document-due';
import type { KitDocument } from '@/entities/document/schemas/kit-document';
import { AttachmentCount } from '@/entities/shared/attachment/attachment-count';
import { DueBadge } from '@/entities/shared/due/due-badge';
import { RecordTitle } from '@/entities/shared/record/record-title';
import { IconTile } from '@/shared/components/icon-tile';
import { ListRow } from '@/shared/components/list/list-row';

type DocumentRowProps = {
  readonly view: RecordView<KitDocument>;
  readonly onOpen: () => void;
};

export function DocumentRow({ view, onOpen }: DocumentRowProps) {
  const doc = view.data;
  return (
    <ListRow
      onClick={onOpen}
      leading={<IconTile icon={DOCUMENT_CATEGORY_LABELS[doc.category].icon} />}
      title={<RecordTitle pending={view.pending}>{doc.title}</RecordTitle>}
      subtitle={
        <span className="flex items-center gap-2">
          <span className="truncate">
            {[doc.holder, doc.original_location].filter(Boolean).join(' · ') || ' '}
          </span>
          <AttachmentCount count={doc.attachments.length} />
        </span>
      }
      trailing={<DueBadge due={documentDue(doc)} />}
    />
  );
}
